/* unplugin-vue-components disabled */import script from "./article.vue?vue&type=script&setup=true&lang=js"
export * from "./article.vue?vue&type=script&setup=true&lang=js"

import "./article.vue?vue&type=style&index=0&id=c023b7ae&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c023b7ae"]])

export default __exports__